
export class ConversationCount {
    public unreadConversationCount: number = 0;
    public activeConversationCount: number = 0;
    public archiveConversationCount: number = 0;
}
